import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import navigationMenuActions from 'redux/actions/navigationMenuActions'
import navigationMenuHelpSelector from 'redux/selectors/navigation_menu/navigation_menu_help_selector'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'
import NavigationHelpView from 'views/navigation_menu/content/help/view'
import navigationMenuHelpItemTypes from 'helpers/enums/navigationMenuHelpItemTypes'

class NavigationMenuHelp extends PureComponent {


	componentDidMount() {
		this.props.actions.initialize()
	}

	showIntercomNewMessage = () => {
		if (this.props.userData.intercomIO) {
			this.props.closeNavigationMenu()
			this.props.actions.helpContactUsSelected()
		}
	}

	showOnboardingGuide = () => {
		this.props.closeNavigationMenu()
		this.props.actions.helpOnboardingGuideSelected()
	}

	FUNCTIONS = {
		[navigationMenuHelpItemTypes.HELP_CENTER]:
			this.props.actions.helpHelpCenterSelected,
		[navigationMenuHelpItemTypes.ONBOARDING_GUIDE]:
			this.showOnboardingGuide,
		[navigationMenuHelpItemTypes.TEACHER_RESOURCES]:
			this.props.actions.helpTeacherResourcesSelected,
		[navigationMenuHelpItemTypes.WHATS_NEW]:
			this.props.actions.helpWhatsNewSelected,
		[navigationMenuHelpItemTypes.PERSONALIZED_NEWS]:
			this.props.actions.helpPersonalizedNewsSelected,
		[navigationMenuHelpItemTypes.CONTACT_US]:
			this.showIntercomNewMessage,
	}

	onNavigationSelected = id => this.FUNCTIONS[id]()

	render() {
		return (
			<NavigationHelpView
				navigateTo={this.props.navigateTo}
				handleNavigationSelected={this.onNavigationSelected}
				shouldAddPeronsalizedNews={this.props.shouldAddPeronsalizedNews}
				shouldShowOnboardingGuideButton={this.props.shouldShowOnboardingGuideButton}
			/>
		)
	}
}

function mapStateToProps(state) {
	return navigationMenuHelpSelector(state)
}

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		initialize: navigationMenuActions.helpInitialize,
		helpHelpCenterSelected: navigationMenuActions.
			helpHelpCenterSelected,
		helpTeacherResourcesSelected: navigationMenuActions.
			helpTeacherResourcesSelected,
		helpWhatsNewSelected: navigationMenuActions.
			helpWhatsNewSelected,
		helpPersonalizedNewsSelected: navigationMenuActions.
			helpPersonalizedNewsSelected,
		helpContactUsSelected: navigationMenuActions.
			helpContactUsSelected,
		helpOnboardingGuideSelected: navigationMenuActions.
			helpOnboardingGuideSelected,
	}, dispatch)
}

NavigationMenuHelp.propTypes = {
	navigateTo: PropTypes.func,
	actions: PropTypes.shape({
		initialize: PropTypes.func.isRequired,
		helpHelpCenterSelected: PropTypes.func.isRequired,
		helpTeacherResourcesSelected: PropTypes.func.isRequired,
		helpWhatsNewSelected: PropTypes.func.isRequired,
		helpPersonalizedNewsSelected: PropTypes.func.isRequired,
		helpContactUsSelected: PropTypes.func.isRequired,
		helpOnboardingGuideSelected: PropTypes.func.isRequired,
	}),
	userData: PropTypes.object,
	closeNavigationMenu: PropTypes.func.isRequired,
	shouldAddPeronsalizedNews: PropTypes.bool,
	shouldShowOnboardingGuideButton: PropTypes.bool,
}

export default connect(mapStateToProps, mapDispatchToProps)(
	NavigationMenuHelp
)
